module.exports = __webpack_public_path__ + "img/cast_ic_incubation.2355010d.svg";